'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _promiseEach = require('promise-each');

var _promiseEach2 = _interopRequireDefault(_promiseEach);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Suite = function () {
  function Suite(title) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Suite);

    if (typeof title !== 'string') {
      throw new Error('`title` should be a "string", but "' + (typeof title === 'undefined' ? 'undefined' : (0, _typeof3.default)(title)) + '" was given');
    }

    this.title = title;
    this.options = options;

    this.suites = [];
    this.orderedSnapshots = [];
    this.snapshotsLookup = {};

    this.beforeAll = [];
    this.beforeEach = [];
    this.afterEach = [];
    this.afterAll = [];
  }

  (0, _createClass3.default)(Suite, [{
    key: 'addBeforeAll',
    value: function addBeforeAll(fn) {
      this.beforeAll.push(fn);
    }
  }, {
    key: 'addBeforeEach',
    value: function addBeforeEach(fn) {
      this.beforeEach.push(fn);
    }
  }, {
    key: 'addAfterEach',
    value: function addAfterEach(fn) {
      this.afterEach.push(fn);
    }
  }, {
    key: 'addAfterAll',
    value: function addAfterAll(fn) {
      this.afterAll.push(fn);
    }
  }, {
    key: 'addSuite',
    value: function addSuite(suite) {
      suite.parent = this;
      this.suites.push(suite);
    }
  }, {
    key: 'addSnapshot',
    value: function addSnapshot(snapshot) {
      snapshot.parent = this;
      this.orderedSnapshots.push(snapshot);
      this.snapshotsLookup[snapshot.fullTitle()] = snapshot;
    }
  }, {
    key: 'hasSnapshot',
    value: function hasSnapshot(title) {
      if (this.snapshotsLookup[title]) {
        return true;
      }
      if (this.suites.find(function (suite) {
        return suite.hasSnapshot(title);
      })) {
        return true;
      }
      return false;
    }
  }, {
    key: 'fullTitle',
    value: function fullTitle() {
      if (this.parent) {
        var parentTitle = this.parent.fullTitle();
        if (parentTitle) {
          return parentTitle + ': ' + this.title;
        }
      }

      return this.title;
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      if (this.parent) {
        return (0, _extends3.default)({}, this.parent.getOptions(), this.options);
      }

      return this.options;
    }
  }, {
    key: 'getSnapshotDefinitions',
    value: function getSnapshotDefinitions() {
      var nestedDefinitions = this.suites.map(function (suite) {
        return suite.getSnapshotDefinitions();
      }).reduce(function (accumulated, definitions) {
        return [].concat((0, _toConsumableArray3.default)(accumulated), (0, _toConsumableArray3.default)(definitions));
      }, []);

      var definitions = this.orderedSnapshots.map(function (snapshot) {
        return snapshot.getDefinition();
      }).filter(function (definition) {
        return definition !== undefined;
      });

      return [].concat((0, _toConsumableArray3.default)(nestedDefinitions), (0, _toConsumableArray3.default)(definitions));
    }
  }, {
    key: 'getSnapshotMarkup',
    value: function getSnapshotMarkup(title) {
      var _this = this;

      return new _promise2.default(function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve, reject) {
          var markup, suiteWithSnapshot, _markup;

          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;

                  if (!_this.snapshotsLookup[title]) {
                    _context.next = 14;
                    break;
                  }

                  _context.next = 4;
                  return _this.runBeforeAll();

                case 4:
                  _context.next = 6;
                  return _this.runBeforeEach();

                case 6:
                  _context.next = 8;
                  return _this.snapshotsLookup[title].getMarkup();

                case 8:
                  markup = _context.sent;
                  _context.next = 11;
                  return _this.runAfterEach();

                case 11:
                  _context.next = 13;
                  return _this.runAfterAll();

                case 13:
                  return _context.abrupt('return', resolve(markup));

                case 14:
                  suiteWithSnapshot = _this.suites.find(function (suite) {
                    return suite.hasSnapshot(title);
                  });

                  if (!suiteWithSnapshot) {
                    _context.next = 24;
                    break;
                  }

                  _context.next = 18;
                  return _this.runBeforeAll();

                case 18:
                  _context.next = 20;
                  return suiteWithSnapshot.getSnapshotMarkup(title);

                case 20:
                  _markup = _context.sent;
                  _context.next = 23;
                  return _this.runAfterAll();

                case 23:
                  return _context.abrupt('return', resolve(_markup));

                case 24:
                  return _context.abrupt('return', reject('Could not find snapshot with title "' + title + '"'));

                case 27:
                  _context.prev = 27;
                  _context.t0 = _context['catch'](0);

                  reject(_context.t0);

                case 30:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this, [[0, 27]]);
        }));

        return function (_x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: 'runBeforeAll',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _promiseEach2.default)(function (fn) {
                  return fn();
                })(this.beforeAll);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runBeforeAll() {
        return _ref2.apply(this, arguments);
      }

      return runBeforeAll;
    }()
  }, {
    key: 'runBeforeEach',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.parent) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.parent.runBeforeEach();

              case 3:
                _context3.next = 5;
                return (0, _promiseEach2.default)(function (fn) {
                  return fn();
                })(this.beforeEach);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function runBeforeEach() {
        return _ref3.apply(this, arguments);
      }

      return runBeforeEach;
    }()
  }, {
    key: 'runAfterEach',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _promiseEach2.default)(function (fn) {
                  return fn();
                })(this.afterEach);

              case 2:
                if (!this.parent) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 5;
                return this.parent.runAfterEach();

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function runAfterEach() {
        return _ref4.apply(this, arguments);
      }

      return runAfterEach;
    }()
  }, {
    key: 'runAfterAll',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _promiseEach2.default)(function (fn) {
                  return fn();
                })(this.afterAll);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function runAfterAll() {
        return _ref5.apply(this, arguments);
      }

      return runAfterAll;
    }()
  }]);
  return Suite;
}();

exports.default = Suite;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@percy/react-percy-test-framework/lib/Suite.js
// module id = 305
// module chunks = 1